import React from 'react';
import clsx from 'clsx';
import styles from './SettingsSectionHeader.module.css';

export interface SettingsSectionHeaderProps {
  title: string;
  description?: string;
  actions?: React.ReactNode;
  sticky?: boolean;
  className?: string;
}

const SettingsSectionHeader: React.FC<SettingsSectionHeaderProps> = ({
  title,
  description,
  actions,
  sticky = false,
  className,
}) => {
  return (
    <div className={clsx(styles.header, sticky && styles.sticky, className)}>
      <div className={styles.copy}>
        <h2 className={styles.title}>{title}</h2>
        {description && <p className={styles.description}>{description}</p>}
      </div>
      {actions && <div className={styles.actions}>{actions}</div>}
    </div>
  );
};

export default SettingsSectionHeader;
